module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dqNNq"))).then(() => module.bundle.root('hEqeo'));